import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, Label, Row, Col, Tooltip } from 'reactstrap';
import { AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';

import { saveAnswer, publishAnswer, loadPosSettings, loadMenus, loadNutrients } from '../../../actions';
import { convertCheckBoxValueToBoolean, transformProductPrice, newDeepCopy } from '../../../utils/CommonUtils';
import {
    MENU_ITEM_SUB_ANSWER,
    MENU_ITEM_TYPE_ANSWER
} from '../../../utils/Constants';
import BatchUpdateConfirmationScreen from './common/batchUpdate/BatchUpdateConfirmationScreen';
import MenuCategoryProductScreen from './MenuCategoryProductScreen';
import ExtraInfoRows from './ExtraInfoRows';
import SnoozeInputs from './common/SnoozeInputs';
import PopoverCommon from './common/PopoverCommon';
import MenuPartsFooter from './common/MenuPartsFooter';
import MainInformation from './common/MainInformation';
import NutrientsList from './common/nutrients/NutrientsList';

class AnswerScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentAnswer: {
                id: -1,
                name: '',
                description: '',
                priority: -1,
                price: null,
                modifyPrice: null,
                maximumQuantity: null,
                active: false,
                origin: '',
                canBePublished: false,
                published: false,
                questionDraftId: -1,
                canBeReassigned: false,
                multipleActivateOrDeactivate: false,
                multipleNameChange: false,
                multipleDescriptionChange: false,
                mealDealProduct: false,
                posId: '',
                answerGroup: null,
                answerGroupObject: {
                    id: null,
                    title: ''
                },
                nutrients: [],
                inactiveUntilTime: null,
                snoozeValue: null,
                answerId: null
            },
            selectedCategoryAndProductIDs: [],
            stateAlreadyCopiedFromProps: false,
            modalSize: props.mealDealProduct,
            nutrientsInfo: false,
            nutrientsArrowIcon: false,
            originPopoverOpen: false,
            activePopoverOpen: false,
            publishTooltipOpen: false,
            modifyPriceTooltip: false,
            isBatchDeactivateBtnPressed: false
        }

        this.toggle = this.toggle.bind(this);
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.changeState = this.changeState.bind(this);
        this.changeConfirmationType = this.changeConfirmationType.bind(this);
        this.saveAnswer = this.saveAnswer.bind(this);
        this.saveCurrentAnswer = this.saveCurrentAnswer.bind(this);
        this.publishAnswer = this.publishAnswer.bind(this);
        this.toggleOriginPopover = this.toggleOriginPopover.bind(this);
        this.toggleActivePopover = this.toggleActivePopover.bind(this);
        this.togglePublishTooltip = this.togglePublishTooltip.bind(this);
        this.toggleBatchDeactivateConfirmation = this.toggleBatchDeactivateConfirmation.bind(this);
        this.changeSnoozeTime = this.changeSnoozeTime.bind(this);
        this.changeNutrientsState = this.changeNutrientsState.bind(this);
    }

    componentDidMount() {
        const { restaurantId, mealDealProduct, posSettings } = this.props;
        this.props.loadPosSettings(restaurantId);
        // In case we can edit/create mealDeals we pass second param to loadMenus/categories/products
        // to select where to save response.data i.e. NOT to override current MenuConfigScreen data
        if (mealDealProduct && (posSettings.type.supportCsvFiles || posSettings.type.id === 7)) {
            this.props.loadMenus(restaurantId, posSettings.type.supportCsvFiles || posSettings.type.id === 7);
        }

        this.props.loadNutrients();

        if (this.props.answer.id) {
            this.copyStateFromProps();
        }
    }

    componentWillUnmount() {
        this.resetModalState();
    }

    copyStateFromProps() {
        const {
            id,
            name,
            active,
            description,
            origin,
            price,
            modifyPrice,
            maximumQuantity,
            canBePublished,
            published,
            canBeReassigned,
            mealDealProduct,
            posId,
            answerGroup,
            nutrients,
            inactiveUntilTime,
            answerId
        } = this.props.answer;

        let modifiedNutrients = [];
        nutrients.map(nutri => {
            let nutriObj = {
                id: nutri.nutrition.id,
                nutritionCode: nutri.nutrition.nutritionCode,
                value: nutri.value
            };

            modifiedNutrients.push(nutriObj);
        });

        this.setState(
            {
                currentAnswer: {
                    id: id,
                    name: name,
                    active: active,
                    description: description,
                    origin: origin,
                    price: price,
                    modifyPrice: modifyPrice,
                    maximumQuantity: maximumQuantity,
                    canBePublished: canBePublished,
                    published: published,
                    canBeReassigned: canBeReassigned,
                    questionDraftId: this.props.questionDraftId,
                    currentQuestionDraftId: this.props.questionDraftId,
                    multipleActivateOrDeactivate: false,
                    multipleNameChange: false,
                    multipleDescriptionChange: false,
                    mealDealProduct: mealDealProduct,
                    posId: posId,
                    answerGroup: answerGroup !== null ? answerGroup.title : null,
                    answerGroupObject: answerGroup,
                    nutrients: modifiedNutrients,
                    inactiveUntilTime: inactiveUntilTime,
                    snoozeValue: null,
                    answerId: answerId,
                    // currentQuestionDraftId is used for reloading answers in its group.
                    // In the flow questionDraftId can be changed, that's why we
                    // are using questionId in loadAnswers action.
                },
                stateAlreadyCopiedFromProps: true,
                modalSize: mealDealProduct
            }
        );
    }

    changeState({ target }) {
        let targetValue = null;
        let index = target.selectedIndex;

        if (target.value === true || target.value === 'true' || target.value === false || target.value === 'false') {
            targetValue = convertCheckBoxValueToBoolean({ target });
        } else if (target.name === 'answerGroup') {
            this.setState({
                currentAnswer: {
                    ...this.state.currentAnswer,
                    answerGroupObject: {
                        id: target.childNodes[index].id,
                        title: target.childNodes[index].value
                    }
                }
            });
        } else {
            targetValue = target.value;
        }

        if (target.name !== 'answerGroup') {
            this.setState({
                currentAnswer: {
                    ...this.state.currentAnswer,
                    [target.name]: targetValue
                }
            });
        }
    }

    changeConfirmationType({ target }) {

        this.setState({
            ...this.state,
            currentAnswer: {
                ...this.state.currentAnswer,
                [target.name]: target.value === 'true' ? true : false
            }
        });
    }

    saveAnswer() {
        if (this.state.currentAnswer.id == -1 && this.props.questionDraftId !== undefined && this.props.questionDraftId !== -1) {
            this.state.currentAnswer.questionDraftId = this.props.questionDraftId;
        }

        if (this.state.currentAnswer.id === -1 || (this.state.currentAnswer.active == this.props.answer.active && this.state.currentAnswer.name === this.props.answer.name
            && this.state.currentAnswer.description === this.props.answer.description)) {
            this.saveCurrentAnswer();
            return;
        } else if (this.state.currentAnswer.mealDealProduct && this.state.currentAnswer.active == this.props.answer.active
            && this.state.currentAnswer.description === this.props.answer.description) {
            this.saveCurrentAnswer();
            return;
        }

        this.toggleBatchDeactivateConfirmation();
    }

    changeSnoozeTime(dateDiffInMinutes) {
        this.setState({
            ...this.state,
            currentAnswer: {
                ...this.state.currentAnswer,
                snoozeValue: dateDiffInMinutes
            }
        });
    }

    toggleBatchDeactivateConfirmation() {
        this.setState({
            ...this.state,
            isBatchDeactivateBtnPressed: !this.state.isBatchDeactivateBtnPressed
        });
    }

    saveCurrentAnswer(publishAnswerCallback) {
        const { restaurantId, itemType } = this.props;
        const { currentAnswer, selectedCategoryAndProductIDs } = this.state;

        const saveOrCreateObject = currentAnswer.id === -1 ? selectedCategoryAndProductIDs : undefined;
        this.props.saveAnswer(currentAnswer, restaurantId, itemType, publishAnswerCallback, saveOrCreateObject);

        if (!publishAnswerCallback) {
            this.toggle(true);
        }
    }

    publishAnswer() {
        const publishAnswerCallback = () => {
            this.props.publishAnswer(this.state.currentAnswer, this.props.itemType);
            this.toggle(true);
        };

        this.saveCurrentAnswer(publishAnswerCallback);
    }

    toggle(saveOrPublish) {
        this.props.onToggle(this.state.currentAnswer, saveOrPublish, this.props.itemType);
        this.resetModalState();
    }

    toggleTooltip() {
        this.setState({
            modifyPriceTooltip: !this.state.modifyPriceTooltip
        });
    }

    togglePublishTooltip() {
        this.setState({
            publishTooltipOpen: !this.state.publishTooltipOpen
        });
    }

    resetModalState() {
        this.state.currentAnswer.id = -1;
        this.state.currentAnswer.name = '';
        this.state.currentAnswer.active = false;
        this.state.currentAnswer.description = '';
        this.state.currentAnswer.origin = '';
        this.state.currentAnswer.price = null;
        this.state.currentAnswer.modifyPrice = null;
        this.state.currentAnswer.canBePublished = false;
        this.state.currentAnswer.published = false;
        this.state.currentAnswer.canBeReassigned = false;
        this.state.currentAnswer.answerGroup = null;
        this.state.stateAlreadyCopiedFromProps = false;
        this.state.isAnswerActive = false;
        this.state.isBatchDeactivateBtnPressed = false;
        this.state.originPopoverOpen = false;
        this.state.activePopoverOpen = false;
        this.state.publishTooltipOpen = false;
    }

    toggleOriginPopover() {
        this.setState({
            originPopoverOpen: !this.state.originPopoverOpen
        });
    }

    renderOriginPopover() {
        const originMsg =
            (this.state.currentAnswer.origin !== undefined && this.state.currentAnswer.origin !== null
                && this.state.currentAnswer.origin.length !== 0) ? this.state.currentAnswer.origin : i18n.t('common:popovers.origin');

        return (
            <PopoverCommon
                isOpen={this.state.originPopoverOpen}
                target="origin"
                toggle={this.toggleOriginPopover}
                textContent={originMsg}
            />
        );
    }

    toggleActivePopover() {
        this.setState({
            activePopoverOpen: !this.state.activePopoverOpen
        });
    }

    negativeDecimalsValidation(e) {
        let inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 43 || inputKeyCode == 45 || inputKeyCode == 69
                || inputKeyCode == 101) e.preventDefault();
        }
    }

    renderActivePopover() {
        return (
            <PopoverCommon
                isOpen={this.state.activePopoverOpen}
                target="active"
                toggle={this.toggleActivePopover}
                textContent={i18n.t('screens:answerScreen.activePopover')}
            />
        );
    }

    renderAnswersForm() {
        let modalHeader = i18n.t('screens:answerScreen.heading');

        return (
            <AvForm id={-1} className="modalQuestionForm" onValidSubmit={this.saveAnswer}>
                <ModalHeader className="modalHeader" toggle={this.toggle}>{modalHeader}</ModalHeader>
                <ModalBody style={{ display: 'flex' }}>
                    {this.renderMainAnswerInformation()}
                    {this.renderNutrients()}
                </ModalBody>
                {this.renderAnswerInfoFooter()}
            </AvForm>
        );
    }

    renderNutrients() {

        return (
            <NutrientsList
                {...this.props}
                isHidden={!this.state.nutrientsInfo}
                item={this.state.currentAnswer}
                changeNutrientsState={this.changeNutrientsState}
            />
        );
    }

    changeNutrientsState(modifiedNutrients) {

        this.setState({
            ...this.state,
            currentAnswer: {
                ...this.state.currentAnswer,
                nutrients: modifiedNutrients
            }
        });
    }

    renderAnswerInfoFooter() {

        return (
            <Fragment>
                <MenuPartsFooter
                    styles={styles}
                    state={this.state}
                    isPublishDisabled={!this.state.currentAnswer.canBePublished ? true : false}
                    publishTooltipMsg={i18n.t('screens:answerScreen.publishTooltip')}
                    onClickPublish={this.publishAnswer}
                    publishTooltipToggle={this.togglePublishTooltip}
                    onClickOrigin={this.toggleOriginPopover}
                    publishedItemId={this.state.currentAnswer.answerId}
                />
                {this.renderOriginPopover()}
            </Fragment>
        );
    }

    renderBatchDeactivateConfirmationScreen() {

        return (
            <BatchUpdateConfirmationScreen
                screen={'answer'}
                isActive={this.state.currentAnswer.active}
                isOpen={this.state.isBatchDeactivateBtnPressed}
                onToggle={this.toggle}
                onSave={this.saveCurrentAnswer}
                onChange={this.changeConfirmationType}
                statusChanged={this.state.currentAnswer.active !== this.props.answer.active}
                nameChanged={this.state.currentAnswer.mealDealProduct ? false : this.state.currentAnswer.name !== this.props.answer.name}
                descriptionChanged={this.state.currentAnswer.description !== this.props.answer.description}
            />
        );
    }

    renderMainAnswerInformation() {
        const { activeGroupStyle, marginLeft, cursorPointer, activeLabel } = styles;
        const isDisabled = (this.props.itemType === MENU_ITEM_SUB_ANSWER) ? true : (!this.state.currentAnswer.canBeReassigned ? true : false);
        const reassignInfoMsg = (this.props.itemType === MENU_ITEM_SUB_ANSWER) ? i18n.t('screens:answerScreen.subAnswerReassign') : i18n.t('screens:answerScreen.cannotReassign');
        const isHidden = (this.props.itemType === MENU_ITEM_SUB_ANSWER) ? false : (this.state.currentAnswer.canBeReassigned);
        const isSubAnswer = this.props.itemType === MENU_ITEM_TYPE_ANSWER && this.props.mealDealProduct;
        const { id, name, active, maximumQuantity, price, modifyPrice, description, answerGroup, questionDraftId } = this.state.currentAnswer;
        let colSize = 12;

        if (this.state.modalSize == true) {
            colSize = 12;
            if (this.state.nutrientsInfo) {
                colSize = 8;
            }
        } else {
            colSize = 12;
        }
        // Hide modify price field and change the price field label to modifyPrice and show the default price in there if the answer is from mealDeal
        const answerIsFromMealDeal = this.props.mealDealProduct;
        let answerPriceContainerSize = null;
        let answerPriceLabel = null;

        (answerIsFromMealDeal) ? answerPriceContainerSize = 5 : answerPriceContainerSize = 4;
        (answerIsFromMealDeal) ? answerPriceLabel = i18n.t('common:form.modifyPrice') : answerPriceLabel = i18n.t('common:form.price');

        return (
            <Fragment>
                {
                    // When assigning categories or products to the currentMealDeal question
                    this.props.mealDealProduct && (this.props.posSettings.type.supportCsvFiles || this.props.posSettings.type.id === 7) && this.state.currentAnswer.id === -1 && this.props.itemType !== MENU_ITEM_SUB_ANSWER ?
                        <Col xs={12} sm={12}>
                            <MenuCategoryProductScreen
                                menusCategoriesProducts={this.props.menusCategoriesProducts}
                                categories={this.props.categories}
                                posSettings={this.props.posSettings}
                                saveCatProdToParent={this.saveCatProdToParent.bind(this)}
                            />
                        </Col> :
                        // Regular product answers 
                        <Col xs="12" sm={colSize}>
                            <MainInformation
                                styles={styles}
                                nameValue={name}
                                onChange={this.changeState}
                                descriptionValue={description}
                                draftName={'questionDraftId'}
                                labelText={i18n.t('screens:answerScreen.reassign')}
                                options={this.props.questions}
                                isDraftDisabled={isDisabled}
                                selectValue={questionDraftId}
                                isMsgHidden={isHidden}
                                reassignInfoMsg={reassignInfoMsg}
                                isSubAnswer={isSubAnswer}
                                answerGroupValue={answerGroup}
                                answerGroups={this.props.answerGroups}
                                itemType={this.props.itemType}
                            />
                            <Row>
                                <Col xs={12} sm={4}>
                                    <AvGroup style={activeGroupStyle} id="activeCheckboxGroup">
                                        <span onClick={this.toggleActivePopover} id="active" style={cursorPointer} >
                                            <MaterialIcon icon="help" color="#ff990a" size={20} />
                                        </span>
                                        {this.renderActivePopover()}
                                        <Label for="active" style={activeLabel}>{i18n.t('common:buttons.active')}</Label>
                                        <AvInput type="checkbox" name="active"
                                            required={false}
                                            value={active}
                                            checked={!!this.state.currentAnswer.active}
                                            onChange={this.changeState}
                                            style={marginLeft} />
                                    </AvGroup>
                                </Col>
                                <Col xs={12} sm={6}>
                                    <p name="maxDuplicates">{i18n.t('common:form.maxDuplicates')}: {id === -1 ? 0 : maximumQuantity}</p>
                                </Col>
                                {
                                    !this.state.currentAnswer.active && this.state.currentAnswer.id !== -1 ?
                                        <SnoozeInputs
                                            changeSnoozeTime={this.changeSnoozeTime}
                                            currentProduct={this.state.currentAnswer}
                                            posSettings={this.props.posSettings}

                                        /> : null
                                }
                                <Col xs={12} sm={answerPriceContainerSize}>
                                    {
                                        this.props.posSettings.type.supportCsvFiles || this.props.posSettings.type.id === 7 ?
                                            <AvGroup style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <Label>{answerPriceLabel}</Label>
                                                <AvInput style={{ maxWidth: 70 }}
                                                    id='price' name='price' type='number'
                                                    min={0} required={true}
                                                    onChange={this.changeState}
                                                    value={transformProductPrice(Number(price))}
                                                    onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                                                />
                                            </AvGroup>
                                            : <p name="price" style={{ paddingLeft: 10 }}>{answerPriceLabel}: {price}</p>
                                    }
                                </Col>
                                <Col xs={12} sm={8} style={{ display: 'flex', alignItems: 'center' }} hidden={answerIsFromMealDeal}>
                                    <p id="modifyPriceTooltip" name="modifyPrice">{i18n.t('common:form.modifyPrice')}: {id === -1 ? '0.00' : transformProductPrice(Number(modifyPrice))}</p>
                                    <Tooltip placement="top" isOpen={this.state.modifyPriceTooltip} target="modifyPriceTooltip" toggle={this.toggleTooltip}>
                                        {i18n.t('screens:answerScreen.modifyPriceTooltip')}
                                    </Tooltip>
                                </Col>
                            </Row>
                            {
                                this.props.itemType !== MENU_ITEM_SUB_ANSWER &&
                                <ExtraInfoRows
                                    state={this.state}
                                    modifyExtraRowsState={(setStateObj) => { this.setState(setStateObj); }}
                                    itemType={this.props.itemType}
                                    mealDealProduct={this.props.mealDealProduct} />
                            }

                        </Col>
                }

            </Fragment>
        );
    }

    checkNutriValue = (nutrient) => {
        let returnValue = '';
        this.state.currentAnswer.nutrients.map(nutri => {
            if (nutri.id === nutrient.id) {
                returnValue = nutri.value;
            }
        });

        return returnValue;
    }

    saveCatProdToParent(selectedCategoryAndProductIDs) {
        this.setState({
            ...this.state,
            selectedCategoryAndProductIDs: selectedCategoryAndProductIDs
        });
    }

    render() {
        const { isOpen } = this.props;

        let modalSize = '', modalClassName = '';
        if (this.state.modalSize === true) {
            modalSize = 'lg';
        } else {
            modalSize = 'md';
        }

        if (!this.state.isBatchDeactivateBtnPressed) {
            return (
                <div>
                    <Modal className={modalClassName} isOpen={isOpen} toggle={this.toggle} size={modalSize}>
                        {this.renderAnswersForm()}
                    </Modal>
                </div>
            );
        } else {
            return (
                <div>
                    {this.renderBatchDeactivateConfirmationScreen()}
                </div>
            );
        }
    }
}

const mapStateToProps = state => {
    return {
        menusCategoriesProducts: state.menusCategoriesProducts,
        questions: state.questions,
        posSettings: state.posSettings,
        nutrients: state.nutrients
    };
};

export default connect(mapStateToProps, { saveAnswer, publishAnswer, loadPosSettings, loadMenus, loadNutrients })(AnswerScreen);

let styles = {
    activeGroupStyle: {
        paddingLeft: '0.4rem',
        width: '100%'
    },
    descriptionStyle: {
        height: 75
    },
    marginLeft: {
        marginLeft: 10
    },
    alignRight: {
        marginLeft: 'auto'
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    popoverStyle: {
        padding: '12px 6px 0px 6px'
    },
    activeLabel: {
        marginLeft: 6
    },
    originStyle: {
        color: '#0288d1',
        marginRight: 'auto',
        padding: 0,
    },
    additionalTextInfo: {
        marginLeft: 5
    },
    textInfo: {
        color: '#737373',
        fontSize: 12
    },
    spaceBetween: {
        paddingLeft: 4
    },
    inputCounter: {
        textAlign: 'right',
        fontSize: 12,
    },
    allAndDietFormGroup: {
        height: 465,
        overflow: 'auto',
        marginBottom: 0
    },
    allAndDietLabel: {
        justifyContent: 'flex-start',
        width: '90%',
        whiteSpace: 'normal'
    },
}


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/AnswerScreen.js